let searchCounter = {};
let availableStores = {};

import Vue from 'vue';

import {EMPTY, LOADING, READY, ERROR} from 'module/constants';
import common from 'module/common';
import store from 'module/store';
import filters from "module/filters";

export const getSearchStore = function (storeName) {
  return _.get(availableStores, storeName, null);
};

export default class {
  constructor(name) {
    searchCounter[name] = searchCounter[name] ? searchCounter[name] + 1 : 1;

    this.name = name;
    this.storeName = `search-${name}-${searchCounter[name]}`;

    availableStores[this.storeName] = this;

    //set action names
    this.init = `${this.storeName}/init`;
    this.view = `${this.storeName}/view`;
    this.paused = `${this.storeName}/paused`;
    this.updateFrom = `${this.storeName}/updateFrom`;
    this.reset = `${this.storeName}/reset`;
    this.search = `${this.storeName}/search`;
    this.clearSearch = `${this.storeName}/clearSearch`;
    this.updateRow = `${this.storeName}/updateRow`;
    this.removeRow = `${this.storeName}/removeRow`;
    this.disableFilters = `${this.storeName}/disableFilters`;
    this.disableUserConfig = `${this.storeName}/disableUserConfig`;
    this.myTasks = `${this.storeName}/myTasks`;
    this.columns = `${this.storeName}/columns`;
    this.sort = `${this.storeName}/sort`;
    this.resetSort = `${this.storeName}/resetSort`;
    this.fetch = `${this.storeName}/fetch`;
    this.fetchFilter = `${this.storeName}/fetchFilter`;
    this.loadMore = `${this.storeName}/loadMore`;

    this.setFilter = `${this.storeName}/setFilter`;
    this.filter = `${this.storeName}/filter`;

    this.clearFilters = `${this.storeName}/clearFilters`;
    this.resetFilters = `${this.storeName}/resetFilters`;

    store.registerModule(this.storeName, this.getModule());
  }

  remove() {
    store.unregisterModule(this.storeName);
  }

  getModule() {
    let searchStore = this;

    const STATE = `${this.storeName}_STATE`;
    const VIEW = `${this.storeName}_VIEW`;
    const MY_TASKS = `${this.storeName}_MY_TASKS`;
    const LOADED_ALL = `${this.storeName}_LOADED_ALL`;
    const SEARCH = `${this.storeName}_SEARCH`;
    const FROM = `${this.storeName}_FROM`;
    const LAST_PAGINATION_VALUE = `${this.storeName}_LAST_PAGINATION_VALUE`;
    const DISABLE_FILTERS = `${this.storeName}_DISABLE_FILTERS`;
    const DISABLE_USER_CONFIG = `${this.storeName}_DISABLE_USER_CONFIG`;
    const FETCH_ID = `${this.storeName}_FETCH_ID`;
    const TOTAL = `${this.storeName}_TOTAL`;
    const ROWS = `${this.storeName}_ROWS`;
    const ACTIONS = `${this.storeName}_ACTIONS`;
    const COLUMNS = `${this.storeName}_COLUMNS`;
    const SORT = `${this.storeName}_SORT`;
    const FILTERS_AVAILABLE = `${this.storeName}_FILTERS_AVAILABLE`;
    const FILTERS_OPTIONS = `${this.storeName}_FILTERS_OPTIONS`;
    const FILTERS_SELECTED = `${this.storeName}_FILTERS_SELECTED`;

    let searchTimeout = null;

    // initial state
    const state = {
      initialised: false,
      state: EMPTY,
      view: {
        type: null,
        subType: null,
        name: null,
        options: {}
      },
      exportUrl: 'file.php?a=portal/search',
      myTasks: false,
      loadedAll: false,
      search: null,
      from: 0,
      lastPaginationValue: null,
      disableFilters: false,
      disableUserConfig: false,
      fetchId: null,
      actions: [],
      columns: {
        show: [],
        available: [],
        default: [],
      },
      sort: {
        keyPath: null,
        direction: -1
      },
      rows: [],
      total: {
        overall: 0,
        filterSelection: 0
      },
      filters: {
        available: [],
        selected: {}
      }
    };

    //actions
    const actions = {
      init({commit, dispatch}, {view, disableFilters, disableUserConfig, myTasks, search, from}) {
        if (from !== undefined && from !== null) {
          commit(FROM, from);
        }

        commit(DISABLE_FILTERS, disableFilters);
        commit(DISABLE_USER_CONFIG, disableUserConfig);
        commit(MY_TASKS, myTasks);
        commit(SEARCH, search);
        commit(VIEW, view);
        dispatch('fetch');
      },
      view({commit, dispatch, state}, {view, override}) {
        const existingView = _.cloneDeep(state.view);

        if (_.isEqual(view, existingView)) {
          return;
        }

        if (override !== true) {
          view = _.merge({}, existingView, view);
        }

        commit(COLUMNS, {
          show: [],
          available: []
        });

        commit(VIEW, view);
        dispatch('resetSort', false);
        dispatch('reset');
      },
      search({commit, dispatch}, search) {
        if (searchTimeout !== null) {
          clearTimeout(searchTimeout);
        }

        searchTimeout = setTimeout(() => {
          searchTimeout = null;
          commit(SEARCH, search);
          dispatch('reset');
        }, 350);
      },
      clearSearch({commit, dispatch}, fetch) {
        commit(SEARCH, null);

        if (fetch === true) {
          dispatch('reset');
        }
      },
      updateRow({commit, state}, {rowId, rowToUpdate}) {
        let rows = _.cloneDeep(state.rows);
        rowToUpdate._searchStore = searchStore.storeName;
        rowToUpdate._searchStoreRowId = rowId;
        rows = rows.map((row) =>
            (filters.formatOID(row._id) === filters.formatOID(rowToUpdate._id) && filters.formatOID(row._searchStoreRowId) === filters.formatOID(rowId))
                ? rowToUpdate
                : row);
        commit(ROWS, rows);
      },
      removeRow({commit, state}, rowToRemove) {
        let rows = _.cloneDeep(state.rows);
        rows = rows.filter((row) => row._id !== rowToRemove._id);
        commit(ROWS, rows);
      },
      setFilter({commit, dispatch, state}, {name, value, fetch}) {
        if (fetch === undefined) {
          fetch = true;
        }

        let selected = _.cloneDeep(state.filters.selected);
        let selectedForFilter = selected[name] || [];
        let indexOfValue = selectedForFilter.indexOf(value);

        if (indexOfValue <= -1) {
          //item needs to be added
          selectedForFilter.push(value);
          selected[name] = selectedForFilter;
        } else {
          //remove item
          selectedForFilter.splice(indexOfValue, 1);

          if (selectedForFilter.length >= 1) {
            //update overall selected
            selected[name] = selectedForFilter;
          } else {
            //remove filter as it has no values
            delete selected[name];
          }
        }

        commit(FILTERS_SELECTED, selected);

        if (fetch === true) {
          dispatch('reset');
        }
      },
      clearFilters({commit, dispatch}, fetch) {
        commit(FILTERS_SELECTED, {});

        if (fetch === true) {
          dispatch('reset');
        }
      },
      resetFilters({commit, dispatch}, {filters, fetch}) {
        commit(FILTERS_SELECTED, filters);

        if (fetch === true) {
          dispatch('reset');
        }
      },
      reset({commit, dispatch}) {
        commit(FROM, 0);
        commit(LAST_PAGINATION_VALUE, null);
        commit(LOADED_ALL, false);
        dispatch('fetch');
      },
      updateFrom({commit, dispatch}, {from, fetch}) {
        commit(FROM, from);

        if (fetch === true) {
          dispatch('fetch');
        }
      },
      disableFilters({commit, dispatch}, disableFilters) {
        commit(DISABLE_FILTERS, disableFilters === true);
        dispatch('reset');
      },
      disableUserConfig({commit, dispatch}, disableUserConfig) {
        commit(DISABLE_USER_CONFIG, disableUserConfig === true);
        dispatch('reset');
      },
      myTasks({commit, dispatch}, myTasks) {
        commit(MY_TASKS, myTasks === true);
        dispatch('reset');
      },
      columns({commit, dispatch}, columns) {
        commit(COLUMNS, columns);
        dispatch('reset');
      },
      sort({commit, dispatch}, sort) {
        commit(SORT, sort);
        dispatch('reset');
      },
      resetSort({commit, dispatch}, reset) {
        commit(SORT, {
          keyPath: null,
          direction: -1
        });

        if (reset !== false) {
          dispatch('reset');
        }
      },
      fetch({commit, dispatch, state, rootGetters}) {
        let idToken = rootGetters['user/idToken']();
        let view = state.view;
        let disableFilters = state.disableFilters;
        let disableUserConfig = state.disableUserConfig;
        let myTasks = state.myTasks;
        let columns = state.columns.show.map(({name, order}) => ({name, order, show: true}));
        let sort = state.sort;
        let search = state.search && state.search.length >= 3 ? state.search : null;
        let from = state.from;
        let lastPaginationValue = state.lastPaginationValue;
        let filterValues = state.filters.selected;

        filterValues = _.isEmpty(filterValues) === false ? filterValues : null;

        commit(STATE, LOADING);

        let fetchId = common.createGuid();

        commit(FETCH_ID, fetchId);

        if (from === 0) {
          //Fetch initial info for search excluding the filters
          common
              .httpPost('search')
              .set('x-search-store', searchStore.storeName)
              .data({
                action: 'searchWithoutFilters',
                idToken,
                view,
                myTasks,
                columns,
                sort,
                search,
                lastPaginationValue,
                filterValues,
                disableUserConfig
              })
              .then((res) => {
                if (fetchId !== state.fetchId) {
                  //another request has overridden this one
                  return;
                }

                commit(STATE, READY);

                if (res.data.rows.length < 25) {
                  commit(LOADED_ALL, true);
                }

                commit(TOTAL, res.data.total);

                commit(ACTIONS, res.data.actions);

                commit(COLUMNS, res.data.columns);

                commit(SORT, res.data.sort);

                let rows = res.data.rows.map((row) => {
                  row._searchStore = searchStore.storeName;
                  row._searchStoreRowId = _.uniqueId(searchStore.storeName);
                  return row;
                });

                commit(ROWS, rows);

                commit(FROM, res.data.from);
                commit(LAST_PAGINATION_VALUE, res.data.lastPaginationValue);

                if (disableFilters === false && state.filters.available.length <= 0 && Object.keys(res.data.filters).length >= 1) {
                  commit(FILTERS_AVAILABLE, res.data.filters);
                }
              }, (error) => {
                commit(STATE, ERROR);
                dispatch('error/error', error, {root: true});
              });
        } else {
          //Fetch the rows only
          common
              .httpPost('search')
              .set('x-search-store', searchStore.storeName)
              .data({
                action: 'searchRowsOnly',
                idToken,
                view,
                myTasks,
                sort,
                search,
                from,
                lastPaginationValue,
                filterValues,
                disableUserConfig
              })
              .then((res) => {
                if (fetchId !== state.fetchId) {
                  //another request has overridden this one
                  return;
                }

                commit(STATE, READY);

                if (res.data.rows.length < 25) {
                  commit(LOADED_ALL, true);
                }

                let rows = res.data.rows.map((row) => {
                  row._searchStore = searchStore.storeName;
                  return row;
                });

                commit(ROWS, state.rows.concat(rows));

                commit(FROM, res.data.from);
                commit(LAST_PAGINATION_VALUE, res.data.lastPaginationValue);
              }, (error) => {
                commit(STATE, ERROR);
                dispatch('error/error', error, {root: true});
              });
        }
      },
      fetchFilter({commit, dispatch, state, rootGetters}, filterNames) {
        let idToken = rootGetters['user/idToken']();
        let view = state.view;
        let filterValues = state.filters.selected;

        common
            .httpPost('search')
            .set('x-search-store', searchStore.storeName)
            .data({
              action: 'searchSingleFilter',
              idToken,
              view,
              filterNames,
              filterValues,
            })
            .then((res) => {
              if (Object.keys(res.data.filters).length >= 1) {
                commit(FILTERS_OPTIONS, res.data.filters);
              }
            }, (error) => {
              commit(STATE, ERROR);
              dispatch('error/error', error, {root: true});
            });
      }
    };

    //getters
    const getters = {
      exportPostData: (state, getters, rootState, rootGetters) => (exportEntity) => {
        let idToken = rootGetters['user/idToken']();
        let action = exportEntity === 'project' ? 'requestExport' : 'search';
        let view = state.view;
        let myTasks = state.myTasks;
        let search = state.search && state.search.length >= 3 ? state.search : null;
        let filterValues = state.filters.selected;
        let exportType = 'EXCEL';
        let parametersForExport = {idToken, action, view, myTasks, search, filterValues, exportType};

        return exportEntity === 'project' ? parametersForExport : JSON.stringify(parametersForExport);
      },
      rows(state) {
        return state.rows ?? [];
      }
    };

    // mutations
    const mutations = {
      [STATE](state, newState) {
        state.state = newState;
      },
      [VIEW](state, view) {
        Vue.set(state, 'view', view);
      },
      [MY_TASKS](state, myTasks) {
        state.myTasks = myTasks === true;
      },
      [DISABLE_FILTERS](state, disableFilters) {
        state.disableFilters = disableFilters === true;
      },
      [DISABLE_USER_CONFIG](state, disableUserConfig) {
        state.disableUserConfig = disableUserConfig === true;
      },
      [LOADED_ALL](state, loadedAll) {
        state.loadedAll = loadedAll === true;
      },
      [SEARCH](state, search) {
        state.search = search;
      },
      [FROM](state, from) {
        state.from = from;
      },
      [LAST_PAGINATION_VALUE](state, lastPaginationValue) {
        state.lastPaginationValue = lastPaginationValue;
      },
      [FETCH_ID](state, fetchId) {
        state.fetchId = fetchId;
      },
      [TOTAL](state, total) {
        state.total = total;
      },
      [ROWS](state, rows) {
        state.rows = rows;
      },
      [ACTIONS](state, actions) {
        state.actions = actions;
      },
      [COLUMNS](state, columns) {
        Vue.set(state.columns, 'show', columns.show);
        Vue.set(state.columns, 'available', columns.available);

        if (columns.default) {
          Vue.set(state.columns, 'default', columns.default);
        }
      },
      [SORT](state, sort) {
        Vue.set(state.sort, 'keyPath', sort.keyPath);
        Vue.set(state.sort, 'direction', sort.direction);
      },
      [FILTERS_AVAILABLE](state, filtersAvailable) {
        state.filters.available = filtersAvailable;
      },
      [FILTERS_OPTIONS](state, filters) {
        filters.forEach((filter) => {
          let existingIndex = state.filters.available.findIndex(currentFilter => currentFilter.name === filter.name);

          if (existingIndex >= 0) {
            Vue.set(state.filters.available[existingIndex], 'options', filter.options);
          }
        });
      },
      [FILTERS_SELECTED](state, filtersSelected) {
        state.filters.selected = filtersSelected;
      }
    };

    return {
      namespaced: true,
      state,
      actions,
      getters,
      mutations
    };
  }
}
